module.exports = "<div id=\"jwplayer\">This text will be removed.</div>"